/**
 * The advertising and analytics tags public pages load: the Google Ads tag
 * (gtag) and Contentsquare. One component instead of the same snippet pasted
 * into seven pages, so a visitor's "Do Not Sell or Share" choice (or their
 * browser's Global Privacy Control signal) switches them all off in one place
 * (src/lib/privacyChoices.js). The ChatGPT Ads pixel loads from index.html
 * and checks the same signals there.
 */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { marketingAllowed, PRIVACY_CHOICE_EVENT } from '@/lib/privacyChoices';

export const GOOGLE_ADS_ID = 'AW-17717012691';
export const CONTENTSQUARE_SRC = 'https://t.contentsquare.net/uxa/0e8245a2fc4bb.js';

export default function MarketingTags({ googleAds = false, contentsquare = false }) {
  const [allowed, setAllowed] = useState(() => marketingAllowed());
  useEffect(() => {
    const update = () => setAllowed(marketingAllowed());
    window.addEventListener(PRIVACY_CHOICE_EVENT, update);
    return () => window.removeEventListener(PRIVACY_CHOICE_EVENT, update);
  }, []);
  if (!allowed || (!googleAds && !contentsquare)) return null;
  return (
    <Helmet>
      {contentsquare && <script src={CONTENTSQUARE_SRC} />}
      {googleAds && <script async src={`https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`} />}
      {googleAds && (
        <script>{`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GOOGLE_ADS_ID}');
        `}</script>
      )}
    </Helmet>
  );
}
MarketingTags.propTypes = { googleAds: PropTypes.bool, contentsquare: PropTypes.bool };
